import { Modal, Button, Form } from "react-bootstrap";
import { useFGReportsFarmGlobal } from "./ReportsFarmGlobalContext";
import MaterialIcon from 'material-icons-react';
import styles from './ReportsFarmGlobal.module.scss';
import Tabela from "../../Misc/Tabela/Tabela";
import { useEffect, useState } from "react";

const ModalReportSuppliers = () => {
  const { showSupplierModal, setShowSupplierModal, setShowSupplierEditModal, supplierModalForm, setSupplierModalForm, handleAddSuppliers, supplierTableData, setSupplierEditModalForm } = useFGReportsFarmGlobal();

  const [supplierListOn, setSupplierListOn] = useState(false);

  const handleSetSupplierModalForm = (index, field, value, subIndex = null) => {
    subIndex !== null ? supplierModalForm[index][field][subIndex] = value : supplierModalForm[index][field] = value;
    setSupplierModalForm([...supplierModalForm]);
  }

  const supplierCols = [
    {
      name: 'Supplier', selector: row => {
        return (
          <>
            <span>{row.supplier} | </span>
            <span
              className={styles.span_active}
              style={{ backgroundColor: row.supplier_active ? '#35dc7090' : '#DC354590' }}
            >
              {row.supplier_active ? 'Active' : 'Inactive'}
            </span>
          </>
        )
      }, width: '40%'
    },
    {
      name: 'FP (PA) | RM (MP)?', selector: row => {
        return `${row.supplies_pa ? 'Yes' : 'No'} | ${row.supplies_mp ? 'Yes' : 'No'}`
      }, width: '20%'
    },
    {
      name: 'Sub-Supplier(s)', selector: (row, index) => {
        if (row.subSuppliers.length > 0) {
          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '10px 0px' }}>
              {row.subSuppliers.map((item, subIndex) => {
                return (
                  <div key={`subs_${index}_${subIndex}`}>
                    <span>{item.subSupplier} | </span>
                    <span
                      className={styles.span_active}
                      style={{ backgroundColor: item.subSupplier_active ? '#35dc7090' : '#DC354590' }}
                    >
                      {item.subSupplier_active ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                );
              })}
            </div>
          )
        } else {
          return ' - ';
        }
      }, width: '40%'
    },
  ];

  const hasDupplicateSupplier = (rowSupplier) => {
    const duplicateSupplier = new Set();
    for (const obj of supplierModalForm) {
      const { supplier } = obj;
      if (duplicateSupplier.has(supplier) && supplier === rowSupplier) return true;
      duplicateSupplier.add(supplier);
    }
    return false;
  }

  const hasDupplicateSubSupplier = (index, rowSubSupplier) => {
    const duplicateSupplier = new Set();
    for (const str of supplierModalForm[index].subSupplier) {
      if (duplicateSupplier.has(str) && str === rowSubSupplier) return true;
      duplicateSupplier.add(str);
    }
    return false;
  }

  return (
    <Modal
      show={showSupplierModal}
      onHide={() => setShowSupplierModal(false)}
      backdrop={'static'}
      keyboard={false}
      centered
      size={'xl'}
      fullscreen={'xl-down'}
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Suppliers</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {
          supplierListOn &&
          <Tabela
            columns={supplierCols}
            data={supplierTableData}
            pagination={false}
            highlightOnHover={true}
            // rowClickedFn={row => {
            //   setSupplierEditModalForm({ ...row });
            //   setShowSupplierEditModal(true);
            // }}
            rowClickedFn={row => {
              const deepCopy = JSON.parse(JSON.stringify(row));
              setSupplierEditModalForm(deepCopy);
              setShowSupplierEditModal(true);
            }}
          />
        }
        {!supplierListOn &&
          <>
            {supplierModalForm.map((item, index) => {
              return (
                <div key={`form_row_${index}`}>
                  <Form style={{ display: 'flex', gap: '20px', padding: '10px 0px' }} key={`supplier_form_${index}`}>
                    <Form.Group style={{ alignSelf: 'center', width: '30%' }}>
                      <Form.Control
                        type={'text'}
                        value={item.supplier || ''}
                        onChange={e => handleSetSupplierModalForm(index, 'supplier', e.target.value)}
                        placeholder={'Supplier'}
                        style={{ width: '100%' }}
                        isInvalid={hasDupplicateSupplier(item.supplier)}
                      >
                      </Form.Control>
                    </Form.Group>

                    <Form.Group style={{ alignSelf: 'center', width: '25%' }}>
                      <Form.Check
                        type={'switch'}
                        style={{ fontSize: '20px' }}
                        label="Supplies Finished Product (PA)?"
                        onChange={() => handleSetSupplierModalForm(index, 'supplier_pa', !supplierModalForm[index].supplier_pa)}
                        value={supplierModalForm[index].supplier_pa}
                        checked={supplierModalForm[index].supplier_pa}
                      />
                      <Form.Check
                        type={'switch'}
                        style={{ fontSize: '20px' }}
                        label="Supplies Raw Material (MP)?"
                        onChange={() => handleSetSupplierModalForm(index, 'supplier_mp', !supplierModalForm[index].supplier_mp)}
                        value={supplierModalForm[index].supplier_mp}
                        checked={supplierModalForm[index].supplier_mp}
                      />
                    </Form.Group>

                    <div className={styles.vertical_separator} />

                    <Form.Group style={{ alignSelf: 'center', display: 'flex', flexDirection: 'column', gap: '6px', width: '30%' }}>
                      {item.subSupplier.map((_, subIndex) => {
                        return (
                          <div key={`subsupplier_${index}_${subIndex}`} style={{ display: 'flex', gap: '6px' }}>
                            <Form.Control
                              type={'text'}
                              value={item.subSupplier[subIndex] || ''}
                              onChange={e => handleSetSupplierModalForm(index, 'subSupplier', e.target.value, subIndex)}
                              placeholder={`Sub-Supplier ${subIndex + 1}`}
                              style={{ width: '100%' }}
                              isInvalid={
                                hasDupplicateSubSupplier(index, item.subSupplier[subIndex]) ||
                                item.subSupplier[subIndex] === ''
                              }
                            />

                            <label
                              className={styles.input_btn_delete}
                              onClick={() => {
                                const updatedForm = [...supplierModalForm];
                                updatedForm[index].subSupplier.splice(subIndex, 1);
                                setSupplierModalForm([...updatedForm]);
                              }}
                            >
                              <MaterialIcon icon="delete" size={20} color={'#DC3545'} />
                            </label>
                          </div>
                        );
                      })}
                      <i
                        className={styles.input_btn}
                        style={{ marginRight: 'auto' }}
                        onClick={() => {
                          const updatedForm = [...supplierModalForm];
                          supplierModalForm[index].subSupplier.push('');
                          setSupplierModalForm([...updatedForm]);
                        }
                        }
                      >
                        <MaterialIcon icon="add_circle" size={20} color={'#007bff'} />
                        &nbsp;Add Sub-Supplier
                      </i>
                    </Form.Group>

                    {
                      index !== 0 &&
                      <label
                        className={styles.input_btn_delete}
                        style={{ justifySelf: 'flex-end', marginLeft: 'auto' }}
                        onClick={() => {
                          const updatedForm = [...supplierModalForm];
                          updatedForm.splice(index, 1);
                          setSupplierModalForm([...updatedForm]);
                        }}
                      >
                        <MaterialIcon icon="delete" size={20} color={'#DC3545'} />
                      </label>
                    }
                  </Form>
                  <div className={styles.separator} />
                </div>
              );
            })}
            <i
              className={styles.input_btn}
              style={{ marginRight: 'auto' }}
              onClick={() => {
                const updatedForm = [...supplierModalForm];
                updatedForm.push({
                  supplier: '',
                  supplier_pa: false,
                  supplier_mp: false,
                  subSupplier: [''],
                });
                setSupplierModalForm([...updatedForm]);
              }}
            >
              <MaterialIcon icon="add_circle" size={20} color={'#007bff'} />
              &nbsp;Add Supplier
            </i>
          </>
        }
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={'secondary'}
          style={{ width: '200px' }}
          onClick={() => setSupplierListOn(!supplierListOn)}
        >
          Supplier List
        </Button>

        <Button
          variant={'success'}
          style={{ width: '200px' }}
          onClick={handleAddSuppliers}
        >
          Add New Suppliers
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalReportSuppliers;
